import React from 'react'
import "./Header.css"
import PlaceIcon from '@mui/icons-material/Place';
import SearchIcon from '@mui/icons-material/Search';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import { Link } from 'react-router-dom';
import { UseStateValue } from './Stateprovider';
import { auth } from './Firebase';

function Header() {
  const [{basket, user}, dispatch] = UseStateValue()
  const handleAuthentication =()=>{
    if(user){
      auth.signOut()
    }
  }
  return (
    <div className='header'>
      <Link to="/">
    <img className='header_logo' src='http://pngimg.com/uploads/amazon/amazon_PNG11.png' alt=''/></Link>
    <div className='adress'>
      <a href='https://us.amazon.com/ref=nav_logo'>
      <span>Select your adress</span>
      <PlaceIcon className='adress_location'/>
      </a>
    </div>
      <input className='header_searchInput' placeholder='Search Amazon' type='text'/> 
      <SearchIcon className="header_searchIcon"/>
    <div className='header_nav'>
      <Link to={!user && "/login"} className='header_clearLink'>
      <div onClick={handleAuthentication} className='header_option'>
      <span className='header_optionLineTwo'>Hello {!user? "Guest":user.email}</span>
      <span className='header_optionLineOne'>{user? "sign out":"sign in"}</span>
      </div>
      </Link>
      <Link to="/orders" className='header_clearLink'>
      <div className='header_option'>
      <span className='header_optionLineTwo'>returns</span>
      <span className='header_optionLineOne'>&orders</span>
      </div>
      </Link>
      <div className='header_option'>
      <span className='header_optionLineOne'>your</span>
      <span className='header_optionLineTwo'>prime</span>
      </div>
      <Link to="/checkout" className='header_clearLink'>
      <div className='header_optionBasket'>
      <ShoppingBasketIcon/>
      <span className='header_optionLineTwo header_basketCount'>{basket.length}</span>
      </div>
      </Link>
    </div>
    </div>
  )
}

export default Header